
import Vue from "vue";
import axios from "axios";
export default Vue.extend({
  data: () => ({
    username: "",
    password: "",
  }),
  methods: {
    login() {
      if (this.username != "" && this.password != "") {
        axios
          .post(Vue.prototype.apiUrl("login"), {
            username: this.username.trim(),
            password: this.password.trim(),
          })
          .then((response) => {
            if (response.data == "success") {
              Vue.prototype.logged = true;
              this.$router.push("/backstage/article");
            } else {
              window.alert("用户名或密码错误");
            }
          })
          .catch(() => {
            window.alert("登录请求失败，请检查网络或稍后重试");
          });
      }
    },
  },
});
